/**
 * Единая формулировка про ИИ-генерацию (чат рецептов).
 * Показ: лист «Что умеет помощник» (`AssistantAboutSheet`).
 */
export const CHAT_AI_GENERATED_DISCLAIMER_RU =
  "Рецепты генерируются искусственным интеллектом. Иногда он может ошибаться. Проверяйте важную информацию.";
